/** One line under the action bar: the first-run tip, then nothing, then the reason a key was
 * refused (UX §9.4). One line, one job, never a toast, never a layout shift — the height is
 * reserved whether or not there is anything to say.
 */
import { useTranslation } from "react-i18next";

export function RefusalLine({ message }: { message: string | null }) {
  const { t } = useTranslation();
  return (
    <p
      data-live-coach
      aria-live="polite"
      className="min-h-6 px-1 text-sm text-[color:var(--ink-2)]"
    >
      {message ? t(message) : " "}
    </p>
  );
}
